import React from 'react';
import CommentIcon from 'mdi-react/CommentIcon';
import DesktopIcon from 'mdi-react/DesktopMacIcon';
import TabletIcon from 'mdi-react/TabletAndroidIcon';
import CellPhoneIcon from 'mdi-react/CellphoneAndroidIcon';

import { colors, icons } from '@crm-framework/theme';

import { Wrapper } from './styled';
import { DeviceIconsType, DeviceType } from './types';

const UNKNOWN_DEVICE = CommentIcon;

export const DEVICE_ICONS: DeviceIconsType = {
  Pc: DesktopIcon,
  Tablet: TabletIcon,
  Mobile: CellPhoneIcon,
  MobileApp: icons.MobileAppIcon,
  Undefined: UNKNOWN_DEVICE,
};

export interface IsOnlineIconProps {
  isOnline: boolean;
  deviceType?: DeviceType;
  iconsSize?: number;
}

export const IsOnlineIcon: React.FC<IsOnlineIconProps> = ({
  isOnline,
  deviceType,
  iconsSize = 20,
}) => {
  const iconColor = isOnline ? colors.SUCCESS : colors.DANGER;
  const titleState = isOnline ? 'online' : 'offline';
  let userDeviceName = 'unknown';
  let Icon = UNKNOWN_DEVICE;

  if (deviceType && DEVICE_ICONS[deviceType]) {
    Icon = DEVICE_ICONS[deviceType];
    userDeviceName = deviceType;
  }

  return (
    <Wrapper
      title={`User is ${titleState}. User's device is ${userDeviceName}`}>
      <Icon color={iconColor} size={iconsSize} />
    </Wrapper>
  );
};
